import { satGlobals } from '../../qaamgo/sat/helper/sat-globals';
import { globalLogger } from '../../qaamgo/helper/global-logger';

var _checkCaptchaNeeded = function () {
    var deferred = $.Deferred();

    $.ajax({
        url: satGlobals.getApiUrl('/api/jobs/captcha'),
        xhrFields: {
            withCredentials: true,
        },
    })
        .done(function (data) {
            deferred.resolve(data.required);
        })
        .fail(function () {
            globalLogger.log('sat captcha fail - check captcha needed failed');

            deferred.reject();
        });

    return deferred;
};

var captchaCallback;
var _startCaptcha = function (captchaKey, callback) {

    if (sessionStorage.getItem('PLAYWRIGHT') === 'true') {
        callback();
        return;
    }

    captchaCallback = callback;
    $.getScript('https://www.google.com/recaptcha/api.js?render=' + captchaKey + '&render=explicit').done(function (
        script,
        textStatus
    ) {
        _renderCaptcha(captchaKey);
    });
};

let captchaRendered = false;

var _renderCaptcha = function (captchaKey) {
    if (captchaRendered) {
        globalLogger.log('sat captcha fail - already rendered');

        captchaCallback();

        return;
    }

    if (
        typeof window.grecaptcha === 'undefined' ||
        typeof window.grecaptcha.render === 'undefined' ||
        typeof window.grecaptcha.execute === 'undefined' ||
        typeof window.grecaptcha.getResponse === 'undefined' ||
        typeof window.grecaptcha.ready === 'undefined' ||
        typeof window.grecaptcha.reset === 'undefined'
    ) {
        setTimeout(function () {
            _renderCaptcha(captchaKey);
        }, 500);

        return;
    }

    window.grecaptcha.render('recaptchaContainer', {
        sitekey: captchaKey,
        size: 'invisible',
        callback: _captchaCallback,
    });

    window.grecaptcha.execute();

    captchaRendered = true;
};

var _captchaCallback = function (token) {
    $('<input>')
        .attr({
            type: 'hidden',
            'data-options-type': 'base',
            id: 'captcha',
            name: 'captcha',
            value: token,
        })
        .appendTo('#sendform');

    captchaCallback();
};

var captcha = {
    _checkCaptchaNeeded: _checkCaptchaNeeded,
    _startCaptcha: _startCaptcha,
};

export { captcha };
